import React from 'react';
import { motion } from 'framer-motion';
import { SlideWrapper } from './SlideWrapper';
import { processSteps } from '../../data/processSteps';
import { EASE_OUT } from '../../utils/motion';
interface StepLayoutProps {
  stepIndex: number;
  illustration: React.ReactNode;
}
export function StepLayout({
  stepIndex,
  illustration
}: StepLayoutProps) {
  const step = processSteps[stepIndex];
  const enter = (delay: number) => ({
    initial: {
      opacity: 0,
      y: 16
    },
    animate: {
      opacity: 1,
      y: 0
    },
    transition: {
      duration: 0.3,
      ease: EASE_OUT,
      delay
    }
  });
  return <SlideWrapper data-id="element-334" data-mp="sy1l29b1cggg">
      <div className="grid grid-cols-1 lg:grid-cols-[1fr_1.1fr] gap-10 lg:gap-16 items-center pt-12 pb-12" data-id="element-335" data-mp="f526c9j2uq9y">
        <div data-id="element-336" data-mp="j5vu92wis52u">
          <motion.div className="flex items-center gap-4 mb-6" {...enter(0.1)} data-id="element-337" data-mp="j7fcv05nes7s">
            <span className="w-11 h-11 rounded-full bg-accent text-primary font-bold flex items-center justify-center" data-id="element-338" data-mp="563170xitcrp">
              {String(step.number).padStart(2, '0')}
            </span>
            <div className="flex items-center gap-1.5" aria-label={`Schritt ${step.number} von ${processSteps.length}`} data-id="element-339" data-mp="3n5vkt08n6lfx">
              {processSteps.map((s, i) => <span key={s.number} className={`h-1.5 rounded-full ${i < stepIndex ? 'w-5 bg-accent' : i === stepIndex ? 'w-9 bg-primary' : 'w-5 bg-gray-200'}`} data-id="element-340" data-mp="1xiv9nvikce" data-mpi={i} />)}
            </div>
          </motion.div>

          <motion.h2 className="text-4xl xl:text-5xl font-bold text-primary leading-tight mb-5" {...enter(0.15)} data-id="element-341" data-mp="3d8h36xazfqm1">
            {step.title}
          </motion.h2>

          <motion.p className="text-lg xl:text-xl text-text-secondary leading-relaxed mb-7" {...enter(0.2)} data-id="element-342" data-mp="2kr4si0jxshl1">
            {step.lead}
          </motion.p>

          <ul className="space-y-3" data-id="element-343" data-mp="jq6y00qtlney">
            {step.points.map((point, i) => <motion.li key={point} className="flex items-start gap-3 text-primary" {...enter(0.25 + i * 0.05)} data-id="element-344" data-mp="ooi6a71gvpv2" data-mpi={i}>
                <span className="mt-2 w-2 h-2 rounded-full bg-accent shrink-0" data-id="element-345" data-mp="thkzuf68uzb9" />
                <span className="text-base xl:text-lg" data-id="element-346" data-mp="ydryro083ajp">{point}</span>
              </motion.li>)}
          </ul>

          {step.highlight && <motion.div className="mt-7 border-l-4 border-accent bg-bg-alt rounded-r-xl px-5 py-4 text-primary font-semibold text-base xl:text-lg leading-snug" {...enter(0.45)} data-id="element-347" data-mp="5pe2bcos8ma9">
              {step.highlight}
            </motion.div>}
        </div>

        <motion.div className="relative w-full h-[340px] xl:h-[440px] bg-bg-alt rounded-3xl overflow-hidden" initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        ease: EASE_OUT,
        delay: 0.2
      }} aria-hidden="true" data-id="element-348" data-mp="1m4p3afpov5kx">
          {illustration}
        </motion.div>
      </div>
    </SlideWrapper>;
}